import z from 'zod';
import { ImageTs } from '../../common';



//all-articles-card
export type AllArticleCard = z.output<typeof AllArticleCardSchema>;
export const AllArticleCardSchema = z.object({
  title: z.string(),
});

//blog-header
export type BlogHeader = z.output<typeof BlogHeaderSchema>;
export const BlogHeaderSchema = z.object({
  title: z.string(),
  subtitle: z.string(),
  picture: ImageTs,
  //categories -> TODO maybe remove from this type and fetch it adhoc
});

//featured-article-card
export type FeaturedArticleCard = z.output<typeof FeaturedArticleCardSchema>;
export const FeaturedArticleCardSchema = z.object({
  title: z.string(),
  // article: ArticleTs.array()
});

//last-article-card
export type LastArticleCard = z.output<typeof LastArticleCardSchema>;
export const LastArticleCardSchema = z.object({
  title: z.string(),
});
